export const light = {
  name: 'LIGHT',
  body: '#FFFFFF',
  primary: 'rgb(7, 71, 166)',
  secondary: '#499bfc',
  tertiary: '#f0be72',
  success: '#27ae60',
  error: '#c0392b',
  text: '#2c3e50',
  textLight: '#95a5a6',
  border: '#bbc1cf',
  snow: '#FFFFFF',
  backdrop: 'rgba(0, 0, 0, 0.1)'
}

export const dark = {
  name: 'DARK',
  body: 'rgba(25, 31, 37, 0.94)',
  primary: '#33ced8',
  secondary: '#499bfc',
  tertiary: '#f0be72',
  success: '#27ae60',
  error: '#c0392b',
  text: '#a0b3c6',
  textLight: '#fafafa',
  border: '#bbc1cf',
  snow: '#FFFFFF',
  backdrop: 'rgba(0, 0, 0, 0.1)'
}



// WEBPACK FOOTER //
// ./src/Styles/Themes.js